import {AuthApi, P_Api} from "./api";
import {NewApi as N_Api} from "./newApi";

const Api = new AuthApi()
const PublicApi = new P_Api()
const NewApi = new N_Api()

export {Api, PublicApi, NewApi}
